import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Spinner } from "reactstrap"

import "./CFButton.scss"

const CFButton = ({ title, onClick, outline = false, icon = null, style = {}, disabled = false, extraClass = "", loading, loadingText, ...rest }) => {
  return (
    <button
      {...rest}
      onClick={onClick}
      className={!disabled ? "component-button " + (outline ? " button-props-outline " : "") + extraClass : "component-button button-props-disabled"}
      style={style}
      disabled={disabled}
    >
      {loading ? (
        <>
          <Spinner size={"sm"} color="white" />
          <p className="button-text">{loadingText}</p>
        </>
      ) : (
        <>
          {icon ? <FontAwesomeIcon icon={icon} /> : ""}
          <p className="button-text">{title}</p>
        </>
      )}
    </button>
  )
}

export default CFButton
